/* 
 * Export component file to be used on project
*/

import { CoreIcons } from './CoreIcons.js';
export default CoreIcons;
